import { useMutation } from "@tanstack/react-query";

import api from "@/api";

export type LinkClassicAccountResponse = {
  linked: boolean;
};

/**
 * Links the current (CHAI/Nori) user to their Curai Classic account using a
 * one-time merge code. Hits `POST /user/link-classic-account` with `{ code }`
 * and expects `{ linked: true }` on success. A 400/404 is
 * surfaced to the caller as an invalid/expired code.
 */
export function useLinkClassicAccount() {
  return useMutation({
    mutationFn: async ({ code }: { code: string }) => {
      const response = await api.post<LinkClassicAccountResponse>(
        "/user/link-classic-account",
        { code },
      );
      return response.data;
    },
    mutationKey: ["user", "linkClassicAccount"],
  });
}
